import {makeAutoObservable, observable, runInAction} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {GameLevel, RequestState, ModalType} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {IContestsStore} from "data/stores/contests/contestsStore";
import type {IGameBarStore} from "data/stores/game_bar/game_bar.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {extractErrorMessage} from "data/utils";

export interface IUserLevelBadgeController extends ViewController {
	get isLoading(): boolean;
	get level(): GameLevel;
}

@injectable()
export class UserLevelBadgeController implements IUserLevelBadgeController {
	@observable _requestState: RequestState = RequestState.IDLE;

	constructor(
		@inject(Bindings.GameBarStore) public readonly _gameBarStore: IGameBarStore,
		@inject(Bindings.ContestsStore) public readonly _contestStore: IContestsStore,
		@inject(Bindings.ModalsStore) public readonly _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get isLoading(): boolean {
		return this._requestState !== RequestState.SUCCESS;
	}

	get level(): GameLevel {
		return GameLevel.SINGLE_A;
	}

	get contest() {
		return this._contestStore.currentContest;
	}
	init(param: void) {
		void this.fetchGameBar();
	}

	private async fetchGameBar() {
		const contest = this.contest;
		if (contest) {
			try {
				this._requestState = RequestState.PENDING;
				await this._gameBarStore.fetchGameBar(contest.id);
				runInAction(() => {
					this._requestState = RequestState.SUCCESS;
				});
			} catch (e) {
				this._requestState = RequestState.ERROR;
				this._modalsStore.showModal(ModalType.ERROR, {
					message: extractErrorMessage(e),
				});
			}
		}
	}
}
